import type { GachaThemeStyles } from '../gacha.theme';

/** Base path for this theme assets */
const folder = 'assets/ui/gacha/valentines';

/** Assets for preload */
const preload = {
  gacha_button_en: `${folder}/buttons/gacha_button_ja.png`,
  gacha_button_ja: `${folder}/buttons/gacha_button_ja.png`,
};

/** All assets for the theme */
const assets = {
  ...preload,
  gacha_popup: `${folder}/background/gacha_popup.png`,
  gacha_button_en: `${folder}/buttons/gacha_button_en.png`,
  gacha_button_ja: `${folder}/buttons/gacha_button_ja.png`,
  timer_bg: `${folder}/buttons/timer_bg.png`,
  shop_banner_en: `${folder}/frames/shop_banner_en.png`,
  shop_banner_ja: `${folder}/frames/shop_banner_ja.png`,
  title_en: `${folder}/icons/gacha_title_en.png`,
  title_ja: `${folder}/icons/gacha_title_ja.png`,
  intro_bg: `${folder}/intro/bg.png`,
  intro_title_en: `${folder}/icons/gacha_title_en.png`,
  intro_title_ja: `${folder}/icons/gacha_title_ja.png`,
  intro_subtitle_en: `${folder}/icons/limitedtimeonly_en.png`,
  intro_subtitle_ja: `${folder}/icons/limitedtimeonly_ja.png`,
};

/** View styles for the  theme */
const styles: GachaThemeStyles = {
  gacha_popup: ({ width, height }) => ({
    width: 714,
    height: 920,
    x: width / 2,
    y: height / 2 - 10,
    image: assets.gacha_popup,
  }),
  gacha_popup_timer: () => ({
    color: '#A8896C',
  }),
  gacha_button_en: () => ({
    image: assets.gacha_button_en,
  }),
  gacha_button_ja: () => ({
    image: assets.gacha_button_ja,
  }),
  timer_bg: () => ({
    image: assets.timer_bg,
  }),
  shop_banner_en: () => ({
    width: 542,
    height: 170,
    image: assets.shop_banner_en,
  }),
  shop_banner_ja: () => ({
    width: 542,
    height: 170,
    image: assets.shop_banner_ja,
  }),
  title_en: () => ({
    width: 358,
    height: 168,
    image: assets.title_en,
  }),
  title_ja: () => ({
    width: 404,
    height: 193,
    image: assets.title_ja,
  }),
  intro_bg: ({ width, height }) => ({
    width,
    height,
    image: assets.intro_bg,
  }),
  intro_title_en: ({ titleY }) => ({
    y: titleY - 30,
    width: 358,
    height: 168,
    image: assets.intro_title_en,
  }),
  intro_title_ja: ({ titleY }) => ({
    y: titleY - 30,
    width: 404,
    height: 193,
    image: assets.intro_title_ja,
  }),
  intro_subtitle_en: () => ({
    x: 111,
    y: 400,
    width: 103,
    height: 106,
    image: assets.intro_subtitle_en,
  }),
  intro_subtitle_ja: () => ({
    x: 111,
    y: 400,
    width: 103,
    height: 106,
    image: assets.intro_subtitle_ja,
  }),
  intro_timer: ({ titleY }) => ({
    y: titleY + 120 + 300,
  }),
  intro_text: ({ height }) => ({
    y: height * 0.65 - 5,
    size: 26,
  }),
  intro_button: ({ height }) => ({
    y: height * 0.8,
  }),
};

export const gachaThemeValentines = {
  styles,
  assets,
  preload,
  folder,
};
